/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.container{
  padding-top: 32px;
  padding-bottom: 32px;
}

.home-banner {
  @apply w-full h-auto rounded-[12px] relative overflow-hidden mx-auto font-poppins;
}

.home-banner .home-banner-slide {
  @apply hidden; 
}

.home-banner .home-banner-slide-0 {
  @apply flex flex-col md:flex-row justify-between items-stretch md:gap-40px;
}

.home-banner .home-banner-slide .home-banner-slide-content {
  @apply w-full h-auto min-h-[480px] md:min-h-[435px] py-40px md:px-0 px-16px flex-1 justify-between gap-y-[56px] md:pl-40px;
}

.home-banner .home-banner-slide .home-banner-slide-content div {
  @apply max-w-[800px];
}


.home-banner .home-banner-slide .home-banner-slide-content #home-banner-slide-items {
  @apply flex flex-row md:block gap-x-[16px];
}

/* .home-banner .home-banner-slide-title {
  @apply text-5 sm:text-7 md:text-7 lg:text-11;
} */

.home-banner .home-banner-slide .home-banner-slide-description {
  @apply mt-24px fs-3; 
}

.home-banner-slide-title {
  @apply fs-6 font-semibold;
}

.home-banner .home-banner-slide .home-banner-slide-buttons .button {
  @apply block;
}

.home-banner .home-banner-slide .home-banner-slide-asset-wrapper {
  @apply w-full h-auto block md:max-w-[50%] md:flex md:justify-end md:aspect-square lg:max-h-[800px] !relative !overflow-hidden;
}

.home-banner .home-banner-slide .home-banner-slide-asset {
  @apply w-full h-full object-cover rounded-[12px] !max-h-[380px] sm:!max-h-[620px] md:!max-h-[100%];
  transition: opacity 0.5s ease; /* Smooth opacity transition */
}

.home-banner .home-banner-slide .home-banner-slide-asset.current-image {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  opacity: 1; /* Fully visible */
}

.home-banner .home-banner-slide .home-banner-slide-asset.next-image {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  opacity: 0; /* Invisible */
}

.home-banner .home-banner-slide .home-banner-slide-asset.placeholder-image {
  position: static;
  opacity: 0; /* Invisible */
}

.home-banner-slide-asset.current {
  z-index: 2; /* Ensures current image is on top */
}

.home-banner-slide-asset.next {
  z-index: 1; /* This image is always ready underneath */
  opacity: 1 !important;
}

.home-banner-slide-preview-item {
  @apply cursor-pointer flex flex-row justify-start items-center w-fit h-auto gap-x-[8px] py-4px;
}

.home-banner-slide-preview-item-bar-wrapper {
  @apply w-fit md:w-[32px] h-auto flex flex-row justify-end items-center;
}

.home-banner-slide-toggle .home-banner-slide-preview-item p {
  @apply hidden md:block transition-opacity hover:opacity-100 fs-1;
  opacity: 0.5;
  transition: opacity 150ms ease;
}

.home-banner-slide-toggle.active .home-banner-slide-preview-item p {
  opacity: 1;
}

.home-banner-slide-preview-item-bar {
  @apply w-[16px] h-[4px] md:w-[16px] md:h-[2px] rounded-[8px];
  transition: width 150ms ease;
}

.home-banner-slide-toggle.active .home-banner-slide-preview-item-bar {
  @apply w-[56px] md:w-[32px];
}

.home-banner-slide-preview-item-bar.bar-0 {
  @apply bg-yellow;
}

.home-banner-slide-preview-item-bar.bar-1 {
  @apply bg-red;
}

.home-banner-slide-preview-item-bar.bar-2 {
  @apply bg-light-blue;
}

.home-banner-slide-preview-item-bar.bar-3 {
  @apply bg-light-green;
}

.home-banner-slide-preview-item-bar.bar-4 {
  @apply bg-yellow;
}

.home-banner-slide-preview-item-bar.bar-5 {
  @apply bg-red;
}

.home-banner-slide-preview-item-bar.bar-6 {
  @apply bg-light-blue;
}

.home-banner-slide-preview-item-bar.bar-7 {
  @apply bg-light-green;
}

.home-banner-slide-preview-item-bar.bar-8 {
  @apply bg-yellow;
}

.home-banner-slide-preview-item-bar.bar-9 {
  @apply bg-red;
}

.home-banner-slide-preview-item-bar.bar-10 {
  @apply bg-light-blue;
}


@media(min-width: 1000px) {
  .home-banner .home-banner-slide .home-banner-slide-content {
    @apply min-h-[655px];
  }

  .home-banner .home-banner-slide .home-banner-slide-content.centered-content {
    @apply !justify-center;
  }
}

@media(min-width: 1000px) and (max-width: 1279px) {
  .home-banner .home-banner-slide-title {
    font-size: 36px;
    line-height: 44px;
  }

  .home-banner .home-banner-slide .home-banner-slide-description {
    font-size: 16px;
    line-height: 24px;
  }
}


/* Animation */
@keyframes fade-in {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;

  }
}

.overlay1, .overlay2 {
  @apply absolute bg-white w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
}

.home-banner-slide.animate .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}

.home-banner-slide.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}


/* Fade Content and asset within the Banner */
.home-banner-slide-content .block.animate-in,
.home-banner-slide-asset-wrapper.animate-in {
  animation: slide-fade-in 0.4s forwards;
}

.home-banner-slide-content .block.animate-out,
.home-banner-slide-asset-wrapper.animate-out {
  animation: slide-fade-out 0.4s forwards;
}

@keyframes slide-fade-in {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes slide-fade-out {
  0% { opacity: 1; }
  100% { opacity: 0; }
}
